<template>
  <div class="card p-3 m-3">
    <div class="mb-3">
      <div class="d-flex justify-content-end w-100">
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          class="mb-2 cursor-pointer"
          @click="onClose"
        >
          <path
            d="M13.4099 11.9999L19.7099 5.70994C19.8982 5.52164 20.004 5.26624 20.004 4.99994C20.004 4.73364 19.8982 4.47825 19.7099 4.28994C19.5216 4.10164 19.2662 3.99585 18.9999 3.99585C18.7336 3.99585 18.4782 4.10164 18.2899 4.28994L11.9999 10.5899L5.70994 4.28994C5.52164 4.10164 5.26624 3.99585 4.99994 3.99585C4.73364 3.99585 4.47824 4.10164 4.28994 4.28994C4.10164 4.47825 3.99585 4.73364 3.99585 4.99994C3.99585 5.26624 4.10164 5.52164 4.28994 5.70994L10.5899 11.9999L4.28994 18.2899C4.19621 18.3829 4.12182 18.4935 4.07105 18.6154C4.02028 18.7372 3.99414 18.8679 3.99414 18.9999C3.99414 19.132 4.02028 19.2627 4.07105 19.3845C4.12182 19.5064 4.19621 19.617 4.28994 19.7099C4.3829 19.8037 4.4935 19.8781 4.61536 19.9288C4.73722 19.9796 4.86793 20.0057 4.99994 20.0057C5.13195 20.0057 5.26266 19.9796 5.38452 19.9288C5.50638 19.8781 5.61698 19.8037 5.70994 19.7099L11.9999 13.4099L18.2899 19.7099C18.3829 19.8037 18.4935 19.8781 18.6154 19.9288C18.7372 19.9796 18.8679 20.0057 18.9999 20.0057C19.132 20.0057 19.2627 19.9796 19.3845 19.9288C19.5064 19.8781 19.617 19.8037 19.7099 19.7099C19.8037 19.617 19.8781 19.5064 19.9288 19.3845C19.9796 19.2627 20.0057 19.132 20.0057 18.9999C20.0057 18.8679 19.9796 18.7372 19.9288 18.6154C19.8781 18.4935 19.8037 18.3829 19.7099 18.2899L13.4099 11.9999Z"
            fill="black"
          />
        </svg>
      </div>
      <div class="flex items-center p-3 txt-grey-900" v-if="patient">
        <div class="w-full">
          <span class="text-xl font-bold"
            ><span>{{ patient.name }}</span> -
            <span>{{ patient.medical_record_name }}</span></span
          >

          <div class="lg:flex justify-between items-center mt-2 font-semibold">
            <div>
              Phòng:
              <span class="font-normal" v-show="patient.admission_room">{{
                patient.admission_room
              }}</span>
              <span class="ml-3"
                >Giường:
                <span class="font-normal" v-show="patient.admission_bed">{{
                  patient.admission_bed
                }}</span>
              </span>
            </div>
            <div>
              {{
                `${getGender()}${getYear()} ${
                  patient.age ? `(${patient.age} tuổi)` : ""
                } `
              }}
            </div>
            <div class="font-normal">
              {{ $globalClinic && $globalClinic.name }}
            </div>
            <div>
              CCCD:
              <span class="font-normal">{{ patient.national_id }}</span>
            </div>
            <div>
              BHXH:
              <span class="font-normal">{{ patient.insurance_number }}</span>
            </div>
            <div>
              PID:
              <span class="font-normal">{{ patient.patient_code }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="Flipped-state-wraper">
      <div class="loading-screen" v-if="loading">
        <div class="spinner-border" role="status">
          <span class="sr-only">Loading...</span>
        </div>
      </div>
      <div class="state-wraper">
        <div
          class="checkpoint-item"
          v-for="checkpoint in states"
          :key="'ckp' + checkpoint.id"
        >
          <p class="fs-14 fw-600 txt-grey-900">{{ checkpoint.name }}</p>
          <div
            class="checklist-item cursor-pointer"
            v-for="checklist in checkpoint.checklists"
            :key="'ckl' + checklist.id"
          >
            <div
              class="d-flex"
              :set="(cklStatus = getChecklistStatus(checklist))"
            >
              <div class="mr-2">
                <svg
                  width="17"
                  height="17"
                  viewBox="0 0 17 17"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <rect
                    x="0.403809"
                    y="0.913086"
                    width="16"
                    height="16"
                    rx="8"
                    :fill="cklStatus ? '#06AB2B' : '#C4C4C4'"
                  />
                  <path
                    d="M13.737 4.91309L6.40365 12.2464L3.07031 8.91309"
                    stroke="white"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
              </div>
              <div>
                <p class="fs-14 fw-500 txt-grey-900 mb-3">
                  {{ checklist.name }}
                </p>
                <div class="d-flex justify-content-between ml--59px">
                  <a
                    href="javascript:;"
                    class="txt-pri fs-13 fw-500"
                    v-if="!checklist.items.length"
                    @click="onChangeChecklistState(checklist)"
                    >{{ checklist.done ? "Chưa hoàn thành" : "Hoàn thành" }}</a
                  >
                  <span v-else>&nbsp;</span>
                  <a
                    href="javascript:;"
                    class="txt-pri fs-13 fw-500 collapsed"
                    data-toggle="collapse"
                    :data-target="'#' + 'checklist_' + checklist.id"
                    aria-expanded="true"
                    aria-controls="collapseOne"
                  >
                    <span class="collapsed-title align-items-center">
                      Chi tiết
                      <svg
                        width="8"
                        height="10"
                        viewBox="0 0 8 10"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                        class="ml-1"
                      >
                        <path
                          d="M0.778817 8.07488L0.778817 1.75988C0.778456 1.51057 0.848706 1.26626 0.981436 1.05521C1.11417 0.844174 1.30395 0.675036 1.52882 0.56738C1.79562 0.441355 2.09247 0.392816 2.38552 0.427293C2.67857 0.461769 2.95604 0.577875 3.18632 0.76238L7.01132 3.91988C7.15429 4.04379 7.26895 4.19699 7.34754 4.36909C7.42613 4.5412 7.4668 4.72818 7.4668 4.91738C7.4668 5.10658 7.42613 5.29356 7.34754 5.46567C7.26895 5.63777 7.15429 5.79097 7.01132 5.91488L3.18632 9.07238C2.95604 9.25689 2.67857 9.37299 2.38552 9.40747C2.09247 9.44195 1.79562 9.3934 1.52882 9.26738C1.30395 9.15972 1.11417 8.99059 0.981436 8.77955C0.848706 8.5685 0.778456 8.32419 0.778817 8.07488Z"
                          fill="#20409B"
                        />
                      </svg>
                    </span>
                    <span class="not-collapse-title align-items-center">
                      Ẩn chi tiết
                      <svg
                        width="10"
                        height="8"
                        viewBox="0 0 10 8"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                        class="ml-1"
                      >
                        <path
                          d="M2.09006 0.447872L8.40506 0.451003C8.65437 0.450766 8.89865 0.521137 9.10962 0.653971C9.3206 0.786806 9.48964 0.976672 9.59719 1.20159C9.72308 1.46846 9.77147 1.76533 9.73685 2.05836C9.70223 2.3514 9.58598 2.62881 9.40136 2.859L6.24197 6.68243C6.11798 6.82534 5.96473 6.93993 5.79259 7.01843C5.62044 7.09693 5.43344 7.13751 5.24424 7.13742C5.05504 7.13732 4.86808 7.09656 4.69601 7.01789C4.52395 6.93922 4.37081 6.82448 4.24697 6.68144L1.09136 2.85488C0.906972 2.62451 0.791004 2.34698 0.756672 2.05391C0.722341 1.76084 0.771029 1.46402 0.897186 1.19728C1.00495 0.972466 1.17418 0.782768 1.38529 0.650142C1.5964 0.517517 1.84075 0.447388 2.09006 0.447872Z"
                          fill="#20409B"
                        />
                      </svg>
                    </span>
                  </a>
                </div>
                <div :id="'checklist_' + checklist.id" class="collapse mt-3">
                  <div
                    class="checklist-item-item mb-2"
                    v-for="item in checklist.items"
                    :key="'item' + item.id"
                    @click="onChangeChecklistItem(item)"
                  >
                    <div class="d-flex">
                      <div class="mr-2">
                        <svg
                          width="13"
                          height="13"
                          viewBox="0 0 13 13"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M8.43913 4.08669L5.86513 6.66669L4.87513 5.67669C4.82134 5.61388 4.75515 5.56287 4.68071 5.52686C4.60627 5.49084 4.52519 5.47061 4.44256 5.46741C4.35993 5.46422 4.27753 5.47815 4.20054 5.50831C4.12354 5.53848 4.05361 5.58423 3.99514 5.6427C3.93667 5.70118 3.89091 5.77111 3.86075 5.8481C3.83058 5.9251 3.81666 6.00749 3.81985 6.09013C3.82304 6.17276 3.84328 6.25384 3.8793 6.32828C3.91531 6.40271 3.96632 6.46891 4.02913 6.52269L5.43913 7.93869C5.49519 7.9943 5.56168 8.0383 5.63479 8.06816C5.70789 8.09801 5.78617 8.11315 5.86513 8.11269C6.02253 8.11203 6.17337 8.04954 6.28513 7.93869L9.28513 4.93869C9.34137 4.88292 9.386 4.81656 9.41647 4.74344C9.44693 4.67032 9.46261 4.5919 9.46261 4.51269C9.46261 4.43349 9.44693 4.35506 9.41647 4.28195C9.386 4.20883 9.34137 4.14247 9.28513 4.08669C9.17271 3.97494 9.02064 3.91222 8.86213 3.91222C8.70362 3.91222 8.55155 3.97494 8.43913 4.08669ZM6.80713 0.0126953C5.62044 0.0126953 4.4604 0.364589 3.47371 1.02388C2.48702 1.68317 1.71798 2.62024 1.26385 3.71659C0.809729 4.81295 0.690909 6.01935 0.92242 7.18324C1.15393 8.34712 1.72538 9.41622 2.56449 10.2553C3.40361 11.0944 4.4727 11.6659 5.63659 11.8974C6.80048 12.1289 8.00687 12.0101 9.10323 11.556C10.1996 11.1018 11.1367 10.3328 11.7959 9.34611C12.4552 8.35942 12.8071 7.19938 12.8071 6.01269C12.8071 5.22476 12.6519 4.44455 12.3504 3.71659C12.0489 2.98864 11.6069 2.32721 11.0498 1.77005C10.4926 1.2129 9.83118 0.770946 9.10323 0.469418C8.37528 0.16789 7.59506 0.0126953 6.80713 0.0126953ZM6.80713 10.8127C5.85778 10.8127 4.92975 10.5312 4.14039 10.0037C3.35104 9.47632 2.73581 8.72666 2.37251 7.84957C2.00921 6.97249 1.91415 6.00737 2.09936 5.07626C2.28457 4.14515 2.74173 3.28987 3.41302 2.61858C4.08431 1.94729 4.93959 1.49013 5.8707 1.30493C6.80181 1.11972 7.76693 1.21477 8.64401 1.57807C9.5211 1.94137 10.2708 2.5566 10.7982 3.34596C11.3256 4.13531 11.6071 5.06334 11.6071 6.01269C11.6071 7.28573 11.1014 8.50663 10.2012 9.40681C9.30107 10.307 8.08017 10.8127 6.80713 10.8127Z"
                            :fill="item.status ? '#2A4BA7' : '#979797'"
                          />
                        </svg>
                      </div>
                      <p class="fs-12 fw-500 txt-grey-900 mb-0">
                        {{ item.name }}
                      </p>
                    </div>
                  </div>
                  <div
                    class="d-flex checklist-item-item"
                    @click="onShowAddStatus(true, checklist.id)"
                  >
                    <div class="mr-2">
                      <svg
                        width="13"
                        height="13"
                        viewBox="0 0 13 13"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M9.90381 5.99902H6.90381V2.99902C6.90381 2.86642 6.85113 2.73924 6.75736 2.64547C6.66359 2.5517 6.53642 2.49902 6.40381 2.49902C6.2712 2.49902 6.14402 2.5517 6.05026 2.64547C5.95649 2.73924 5.90381 2.86642 5.90381 2.99902V5.99902H2.90381C2.7712 5.99902 2.64402 6.0517 2.55026 6.14547C2.45649 6.23924 2.40381 6.36642 2.40381 6.49902C2.40381 6.63163 2.45649 6.75881 2.55026 6.85258C2.64402 6.94634 2.7712 6.99902 2.90381 6.99902H5.90381V9.99902C5.90381 10.1316 5.95649 10.2588 6.05026 10.3526C6.14402 10.4463 6.2712 10.499 6.40381 10.499C6.53642 10.499 6.66359 10.4463 6.75736 10.3526C6.85113 10.2588 6.90381 10.1316 6.90381 9.99902V6.99902H9.90381C10.0364 6.99902 10.1636 6.94634 10.2574 6.85258C10.3511 6.75881 10.4038 6.63163 10.4038 6.49902C10.4038 6.36642 10.3511 6.23924 10.2574 6.14547C10.1636 6.0517 10.0364 5.99902 9.90381 5.99902Z"
                          fill="#5C6277"
                        />
                      </svg>
                    </div>
                    <p class="fs-12 fw-500 txt-grey-900 mb-0">Tạo mới</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      class="modal fade"
      id="modalAddStatus"
      tabindex="-1"
      role="dialog"
      aria-labelledby="modalAddStatusLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
          <div class="d-flex justify-content-end p-2">
            <svg
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              class="mb-2"
              data-dismiss="modal"
              aria-label="Close"
            >
              <path
                d="M13.4099 11.9999L19.7099 5.70994C19.8982 5.52164 20.004 5.26624 20.004 4.99994C20.004 4.73364 19.8982 4.47825 19.7099 4.28994C19.5216 4.10164 19.2662 3.99585 18.9999 3.99585C18.7336 3.99585 18.4782 4.10164 18.2899 4.28994L11.9999 10.5899L5.70994 4.28994C5.52164 4.10164 5.26624 3.99585 4.99994 3.99585C4.73364 3.99585 4.47824 4.10164 4.28994 4.28994C4.10164 4.47825 3.99585 4.73364 3.99585 4.99994C3.99585 5.26624 4.10164 5.52164 4.28994 5.70994L10.5899 11.9999L4.28994 18.2899C4.19621 18.3829 4.12182 18.4935 4.07105 18.6154C4.02028 18.7372 3.99414 18.8679 3.99414 18.9999C3.99414 19.132 4.02028 19.2627 4.07105 19.3845C4.12182 19.5064 4.19621 19.617 4.28994 19.7099C4.3829 19.8037 4.4935 19.8781 4.61536 19.9288C4.73722 19.9796 4.86793 20.0057 4.99994 20.0057C5.13195 20.0057 5.26266 19.9796 5.38452 19.9288C5.50638 19.8781 5.61698 19.8037 5.70994 19.7099L11.9999 13.4099L18.2899 19.7099C18.3829 19.8037 18.4935 19.8781 18.6154 19.9288C18.7372 19.9796 18.8679 20.0057 18.9999 20.0057C19.132 20.0057 19.2627 19.9796 19.3845 19.9288C19.5064 19.8781 19.617 19.8037 19.7099 19.7099C19.8037 19.617 19.8781 19.5064 19.9288 19.3845C19.9796 19.2627 20.0057 19.132 20.0057 18.9999C20.0057 18.8679 19.9796 18.7372 19.9288 18.6154C19.8781 18.4935 19.8037 18.3829 19.7099 18.2899L13.4099 11.9999Z"
                fill="black"
              />
            </svg>
          </div>
          <div class="modal-body pt-0">
            <label class="fs-14 fw-500 txt-grey-900 mb-1">Tên</label>
            <div>
              <el-select
                v-model="checklist_item_name"
                filterable
                allow-create
                default-first-option
                reserve-keyword
                :remote-method="searchSuggestionChecklistItem"
                class="w-100"
                no-data-text="Nhập để tạo mới"
              >
                <el-option
                  v-for="item in suggestion_checklist_item"
                  :key="item.id + 'suggestion_checklist_item'"
                  :label="item.name"
                  :value="item.name"
                />
              </el-select>
            </div>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn bg-pri bd-pri text-white"
              :disabled="!checklist_item_name"
              @click="onCreateStatus"
            >
              Tạo
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import appUtils from '../../utils/appUtils'
export default {
  name: 'MRSate',
  data () {
    return {
      mr: null,
      patient: null,
      medicalRecordMain: null,
      states: null,
      checklist_item_name: '',
      checklist_selected: 0,
      loading: true,
      suggestion_checklist_item: []
    }
  },
  mounted () {
    this.getDetailBADT()
    this.getMRStates()
  },
  methods: {
    onClose () {
      this.$router.push({ name: 'ElectronicMedicalRecords', params: { id: this.$route.params.id } })
    },
    async getDetailBADT () {
      this.idMedicalRecords = this.$route.params.id
      if (!this.idMedicalRecords) {
        return
      }
      const res = await this.$rf.getRequest('DoctorRequest').getDetailBADT(this.idMedicalRecords)
      this.mr = res.data
      this.medicalRecordMain = res.data?.medical_record_master
      const patient = {
        ...res.data.patient,
        medical_record_name: res.data.medical_record_name
      }
      if (this.medicalRecordMain && this.medicalRecordMain.admission_room) {
        patient.admission_room = this.medicalRecordMain.admission_room
      }
      if (this.medicalRecordMain && this.medicalRecordMain.admission_bed) {
        patient.admission_bed = this.medicalRecordMain.admission_bed
      }
      this.patient = patient
    },
    async getMRStates () {
      let id = this.$route.params.id
      if (!id) {
        return
      }
      this.loading = true
      await this.$rf.getRequest('DoctorRequest').getMRStates(id).then((r) => {
        this.states = r.data
        console.log(this.states)
      }).finally(() => {
        this.loading = false
      })
    },
    onChangeChecklistItem (item) {
      if (!item) return
      let string = ''
      if (item.status) {
        string = 'Xác nhận đổi trạng thái sang "Chưa hoàn thành"?'
      } else {
        string = 'Xác nhận đổi trạng thái sang "Hoàn thành"?'
      }
      if (!confirm(string)) return
      window.event.stopPropagation()
      this.changeMRState(item, 2)
    },
    onChangeChecklistState (item) {
      if (!item) return
      let string = ''
      if (item.done) {
        string = 'Xác nhận đổi trạng thái sang "Chưa hoàn thành"?'
      } else {
        string = 'Xác nhận đổi trạng thái sang "Hoàn thành"?'
      }
      if (!confirm(string)) return
      window.event.stopPropagation()
      this.changeMRState(item, 1)
    },
    async changeMRState (item, type = 2) {
      let id = this.$route.params.id
      if (!id) {
        return
      }
      if (!item) return
      let params = {
        check_type: type,
        status: !item.status
      }
      await this.$rf.getRequest('DoctorRequest').changeMedicalRecordState(id, item.id, params).then((r) => {
        this.getMRStates()
        this.$toast.open({
          message: 'Thành công',
          type: 'success'
        })
      }).catch(() => {
        this.$toast.open({
          message: 'Thất bại',
          type: 'warning'
        })
      })
    },
    async onCreateStatus () {
      let id = this.$route.params.id
      if (!id) {
        return
      }
      if (!this.checklist_item_name || !this.checklist_selected) return
      let params = {
        mr_checklist_id: this.checklist_selected,
        mr_id: id,
        name: this.checklist_item_name
      }
      await this.$rf.getRequest('DoctorRequest').createMRChecklistStatus(params).then((r) => {
        this.getMRStates()
        this.onShowAddStatus(false, null)
        this.$toast.open({
          message: 'Thành công',
          type: 'success'
        })
      }).catch(() => {
        this.$toast.open({
          message: 'Thất bại',
          type: 'warning'
        })
      })
    },
    getImageURL (avatar) {
      return appUtils.getImageURL(avatar)
    },
    getGender () {
      return appUtils.getGender(this.patient.gender)
    },
    getYear () {
      if (!this.patient.birthday) return ' '
      return ', ' + window.moment(this.patient.birthday).format('YYYY')
    },
    getChecklistStatus (ckl) {
      if (!ckl?.items?.length) {
        return ckl.done
      } else {
        let pedingFirst = ckl?.items.find(item => !item.status)
        return !pedingFirst
      }
    },
    onShowAddStatus (s, cklId) {
      window.event.stopPropagation()
      this.checklist_selected = cklId
      this.getSuggestionChecklistItem(cklId)
      window.$('#modalAddStatus').modal(s ? 'show' : 'hide')
    },
    openCheckListDetail (id) {
      window.$('#' + id).collapse('toggle')
    },
    searchSuggestionChecklistItem (search) {
      this.getSuggestionChecklistItem(this.checklist_selected, search)
    },
    async getSuggestionChecklistItem (checklistId, search) {
      if (!checklistId) {
        return
      }
      let params = {
        checklist_id: checklistId,
        limit: 50
      }
      if (search) {
        params.search = search
      }
      this.loading = true
      await this.$rf.getRequest('DoctorRequest').getSuggestionChecklistItem(params).then((r) => {
        this.suggestion_checklist_item = r.data?.data
      }).finally(() => {
        this.loading = false
      })
    }
  }
}
</script>

<style scoped>
.Flipped-state-wraper {
  position: relative;
  width: 100%;
  overflow: auto;
  min-height: 50vh;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
}
.state-wraper {
  padding-top: 8px;
  width: 100%;
  display: flex;
}

.checkpoint-item {
  min-width: 200px;
  max-width: 200px;
  margin-right: 30px;
}
.checklist-item {
  width: 200px;
  background-color: #f2f6ff;
  border: 1px solid #20419b;
  border-radius: 10px;
  padding: 8px;
  margin-bottom: 20px;
}
.checklist-item-item {
  cursor: pointer;
}
.checklist-item-item:hover p {
  color: black;
}
.checklist-item-item svg,
.checklist-item svg {
  margin-top: -4px;
}

::-webkit-scrollbar {
  height: 6px;
}

::-webkit-scrollbar-track {
  background: #f1f1f1;
}
/* Handle */
::-webkit-scrollbar-thumb {
  background: rgb(172, 172, 172);
}

/* Handle on hover */
::-webkit-scrollbar-thumb:hover {
  background: #555;
}
.loading-screen {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
}
.ml--59px {
  margin-left: -17px;
  width: 200px;
  padding-right: 32px;
}
.not-collapse-title {
  display: flex;
}
.collapsed-title {
  display: none;
}
.not-collapse-title svg,
.collapsed-title svg {
  margin-top: 1px;
}
.collapsed .not-collapse-title {
  display: none !important;
}
.collapsed .collapsed-title {
  display: flex !important;
}
</style>